<div *ngIf="(createStatus$ | async) !== createStatusType.success">
	<form
		#companyForm="ngForm"
		(ngSubmit)="onSubmit(companyForm)"
		class="flex flex-col"
	>
		<app-container type="dark" size="small" [testHook]="testHooks.Container">
			<div class="flex flex-col">
				<div class="flex justify-between items-end">
					<app-input
						label="Company name"
						name="name"
						type="text"
						[required]="true"
						[(ngModel)]="company.name"
						[submitted]="submitted"
						[ngClass]="{ 'mt-4': minify }"
						[testHook]="testHooks.CompanyName"
					></app-input>
					<app-checkbox
						label="Primary contact"
						*ngIf="showPrimaryClientOption"
						name="primary"
						[(ngModel)]="primary"
						class="ml-4"
						[testHook]="testHooks.PrimaryContactCheckbox"
					></app-checkbox>
				</div>
				<div [ngClass]="{ hidden: minify, 'flex flex-col': !minify }">
					<app-input
						label="Business phone"
						name="phoneNumber"
						type="tel"
						[submitted]="submitted"
						[(ngModel)]="phoneNumber"
						class="mx-1 mt-4"
						[testHook]="testHooks.BusinessPhone"
					></app-input>
					<app-input
						label="Business fax"
						name="faxNumber"
						type="tel"
						[submitted]="submitted"
						[(ngModel)]="fax"
						class="mx-1 mt-4"
						[testHook]="testHooks.BusinessFax"
					></app-input>
					<app-input
						label="Business email"
						name="email"
						type="email"
						[email]="true"
						[submitted]="submitted"
						[(ngModel)]="email"
						class="mx-1 mt-4"
						[testHook]="testHooks.BusinessEmail"
					></app-input>
				</div>
			</div>
		</app-container>
		<div class="flex items-start mt-5" *ngIf="enableSigningOfficers">
			<h4>Signing Officer</h4>
			<app-button
				(onClick)="addSigningOfficer()"
				size="small"
				class="ml-5"
				[icon]="ICON.ADD"
				[testHook]="testHooks.AddNewButton"
				>Add new</app-button
			>
		</div>
		<ng-container *ngIf="enableSigningOfficers">
			<app-container
				*ngFor="let item of company.signingOfficers; let i = index"
				type="dark"
				size="small"
				class="mt-5"
				[testHook]="testHooks.Container1"
			>
				<div class="flex items-end">
					<app-button
						btn="tertiary"
						(onClick)="removeSigningOfficer(i)"
						[testHook]="testHooks.RemoveButton"
						>remove</app-button
					>
				</div>
				<div class="flex justify-between">
					<h4>Details</h4>
					<app-checkbox
						label="Set as primary contact"
						[testHook]="testHooks.SetAsPrimaryContactCheckbox"
					></app-checkbox>
				</div>
				<div class="grid grid-cols-3 gap-2">
					<app-input
						class="col-span-3"
						label="Authorized signing officer"
						[name]="'name' + i"
						[(ngModel)]="item.name"
						[required]="true"
						[submitted]="submitted"
						[capitalizeInput]="true"
						[testHook]="testHooks.AuthorizedSigningOfficer"
					></app-input>
					<app-input
						label="Title"
						[(ngModel)]="item.title"
						[name]="'title' + i"
						[capitalizeInput]="true"
						[testHook]="testHooks.Title"
					></app-input>
					<app-input
						label="Phone number"
						[(ngModel)]="item.phone"
						[name]="'cell' + i"
						[testHook]="testHooks.PhoneNumber"
					></app-input>
					<app-input
						label="Email"
						[(ngModel)]="item.email"
						[name]="'email' + i"
						[testHook]="testHooks.Email"
					></app-input>
				</div>
			</app-container>
		</ng-container>

		<div *ngIf="error" class="mt-2">{{ error }}</div>

		<div class="flex justify-between mt-4">
			<app-button
				type="button"
				btn="secondary"
				size="small"
				(click)="cancel()"
				[testHook]="testHooks.CancelButton"
				>Cancel</app-button
			>
			<app-button type="submit" size="small" [testHook]="testHooks.SaveButton"
				>Save</app-button
			>
		</div>
	</form>
</div>
